import React from 'react';
import { Select } from 'antd';
import {
  useSearchParamsSelector,
  useSearchParamsMethods,
} from '../../../../shared/packages/searchParamsManager';
import {
  searchParamKeys,
  calendarModeMap,
  searchParamSelectors,
} from '../../../../shared/configs/searchParams';
import styles from './index.module.scss';

const { calendarMode: modeKey } = searchParamKeys;

const options = [
  { key: calendarModeMap.day, content: 'День' },
  { key: calendarModeMap.week, content: 'Неделя' },
  { key: calendarModeMap.month, content: 'Месяц' },
];

const SelectCalendarMode = () => {
  const mode = useSearchParamsSelector(searchParamSelectors[modeKey]);

  const { setParams } = useSearchParamsMethods();

  const handleChange = (value) => {
    setParams({
      [modeKey]: value,
    });
  };

  return (
    <Select value={mode} onChange={handleChange} className={styles.root}>
      {options.map(({ key, content }) => (
        <Select.Option key={key} value={key}>
          {content}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectCalendarMode;
